import type { ReactNode } from 'react';
import { Icon } from '@/lib/icons';

export interface StatProps {
  label: string;
  value: ReactNode;
  /** Change indicator, e.g. "+18%". Rendered with color from `tone ?? trend`. */
  delta?: string;
  trend?: 'up' | 'down';
  /** Overrides which direction reads as "good" (e.g. cost-per-lead down is good → tone="up"). */
  tone?: 'up' | 'down';
  sub?: string;
  /** Optional explainer shown on an ⓘ next to the label (native tooltip). */
  info?: string;
}

export function Stat({ label, value, delta, trend, tone, sub, info }: StatProps) {
  const good = (tone ?? trend) === 'up';
  return (
    <div className="tr-stat">
      <div className="tr-stat__label">
        {label}
        {info && (
          <span className="tr-stat__info" title={info} tabIndex={0} role="img" aria-label={info}>
            <Icon name="info" size={12} />
          </span>
        )}
      </div>
      <div className="tr-stat__value">{value}</div>
      {(delta || sub) && (
        <div className="tr-stat__foot">
          {delta && (
            <span className={`tr-stat__delta tr-stat__delta--${good ? 'up' : 'down'}`}>{delta}</span>
          )}
          {sub && <span className="tr-stat__sub">{sub}</span>}
        </div>
      )}
    </div>
  );
}
